<template>
  <div class="screen-container">
    <mq-layout :mq="['mobile', 'tablet']">
      <div class="theme-button-container">
        <div v-for="quiz in quizList" :key="quiz.id" class="quizList">
          <div
            class="container"
            :style="backgroundStyle(quiz.tileImage)"
            @click="generateRandomQuizAndOpenIt(quiz.id)"
          >
            <div class="Title">
              {{ quiz.name }}
            </div>
          </div>
          <div class="go" @click="generateRandomQuizAndOpenIt(quiz.id)">
            <div>{{ $t('quiz.startQuiz') }}</div>
          </div>
        </div>
      </div>
    </mq-layout>

    <mq-layout mq="desktop">
      <div class="header-shadow" :style="{ backgroundImage: 'url(' + bgImg + ')' }"></div>
      <div class="container-desktop">
        <div class="block">
          <div class="desktop-wrapper" v-for="quiz in quizList" :key="quiz.id">
            <vv-desktop-tile
              :title="quiz.name"
              @click="generateRandomQuizAndOpenIt(quiz.id)"
              :image="quiz.tileImage"
            />
          </div>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { GENERATE_RANDOM_QUIZ } from '@/store/modules/quiz/types'
import userMixin from '@/mixins/user'
import VvScreenWrapper from '@/components/common/VvScreenWrapper'
import VvBox from '@/components/common/VvBox'
import SimpleHeader from '@/components/navigation/SimpleHeader'
import VvDesktopTile from '@/components/common/VvDesktopTile'

export default {
  name: 'QuizList',
  components: { VvDesktopTile, SimpleHeader, VvBox, VvScreenWrapper },
  mixins: [userMixin],
  data() {
    return {
      bgImg: require('@/assets/background-quizz.jpg')
    }
  },
  computed: {
    ...mapGetters({ quizList: 'getQuizzes' })
  },
  methods: {
    generateRandomQuizAndOpenIt(quizId) {
      this.$store.dispatch(GENERATE_RANDOM_QUIZ, { contentType: 'quiz', contentId: quizId })

      this.$router.push({
        name: 'quiz',
        params: {
          contentType: 'quiz',
          contentId: quizId,
          quizId: quizId
        }
      })
    },
    backgroundStyle(image) {
      return image ? `background: center / cover no-repeat url(${image})` : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.header-shadow {
  margin-top: 75px; //for navbar
  width: 100%;
  height: 625px;
  background-attachment: fixed;
}
.container-desktop {
  display: flex;
  flex-direction: column;
  border-radius: 60px 60px 0px 0px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  float: left;
  position: absolute;
  margin-top: -60px;
}
.block {
  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 0px 0px;
  padding-top: 60px;
  width: 100%;
  height: 100%;
  float: left;
  align-items: center;
}
.title {
  text-align: center;
  font: normal normal 600 25px/30px Montserrat;
  letter-spacing: 0px;
  color: #000000;
}
.leftButton {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.backButton {
  margin-right: 35px;
  cursor: pointer;
  background-color: #ffffff;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow: 3px 3px 3px #bebebe, -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  &:hover {
    box-shadow: -3px -3px 4px #bebebe, 3px 3px 2px #ffffff;
  }
}
.go {
  display: flex;
  margin-top: -20px;
  width: 80px;
  height: 35px;
  padding: 0 15px;
  background: $primary 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  font: normal normal normal 17px/61px Helvetica;
  letter-spacing: 0px;
  color: #ffffff;
  align-items: center;
  justify-content: center;
}
.quizList {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
}
.Title {
  text-align: center;
  font-size: 30px;
  letter-spacing: 0px;
  color: #ffffff;
  text-shadow: 0px 3px 6px #1d1c1c;
  opacity: 1;
}
.container {
  padding: 30px;
  display: flex;
  width: 80%;
  @media screen and (max-width: 400px) {
    height: 200px;
  }
  height: 350px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 3px 10px rgba(216, 216, 216, 0.5);
  border-radius: 10px;
  margin-top: 15px;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 48px;
  padding-bottom: 10px;
}
.theme-button-container {
  padding: 0 10px;
  margin-top: 15px;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 35px;

  .theme-button {
    width: 40%;

    &.first {
      margin-right: 10%;
    }
  }

  .step-item-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.desktop-wrapper {
  display: inline-block;
  width: 70%;
  padding-right: 20px;
  box-sizing: border-box;
  vertical-align: top;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
}
</style>
